import KunLoading88 from './src/index'

KunLoading88.install = function (Vue) {
	Vue.component(KunLoading88.name, KunLoading88);
}

export default KunLoading88;
